const AboutZeuss = () => {
  return (
    <>
      <section className="zbg"></section>
      <section className="WhatPrcog TribeFuture pb-0" id="about">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="heading">
                <h4>The Future of Play-to-Earn Gaming</h4>
                <p>
                  A mythical arena where AI, blockchain, and gaming collide—earn
                  tokens, own NFTs, and rule the metaverse.
                </p>
              </div>
            </div>
            <div className="col-sm-12 col-md-12 col-lg-6">
              {/* <div data-aos="fade-right" data-aos-duration="2000"> */}
              <div className="image">
                <img src="/images/whatzeuss.png" alt="" />
              </div>
              {/* </div> */}
            </div>
            <div className="col-sm-12 col-md-12 col-lg-6">
              {/* <div data-aos="fade-left" data-aos-duration="2000"> */}
              <div className="content">
                <img src="/images/quote.png" alt="" />
                <h4>
                  ZForge is a Play-to-Earn (P2E) game and metaverse where
                  players compete in a mythical arena, earning ZForge
                  Tokens and NFTs through quests, battles, and staking. Powered
                  by AI and blockchain, ZForge offers a unique blend of
                  strategy, storytelling, and true digital ownership.
                </h4>
                <h4>
                  Join us as we revolutionize gaming and create a new era of
                  immersive, rewarding experiences.
                </h4>
                {/* <div className="label">
                  <h5>Your Name</h5>
                  <span>Co-Founder of</span>
                  <label></label>
                </div> */}
              </div>
              {/* </div> */}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default AboutZeuss;
